'use strict';

export default function($stateProvider) {
  'ngInject';
  $stateProvider
    .state('quiz', {
      url: '/quiz',
      template: '<quiz></quiz>'
    });
}



// WEBPACK FOOTER //
// ./client/app/quiz/quiz.routes.js